import { z } from 'zod';
import { apiEnvelope } from '../envelope';
import { surfaceDocumentSchema } from './types';

/** Response metadata is separate from the legacy strict document envelope. */
export const homeRegionOutcomeSchema = z
  .object({
    outcome: z.enum(['ready', 'empty', 'pending', 'unavailable', 'unknown']),
    completeness: z.enum(['complete', 'partial', 'unknown']),
    reason: z.enum([
      'none',
      'read_failed',
      'invalid_content',
      'generation_pending',
      'unavailable_evidence',
    ]),
  })
  .superRefine((value, context) => {
    if (
      value.outcome === 'empty' &&
      (value.completeness !== 'complete' || value.reason !== 'none')
    ) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Empty requires complete successful evidence',
        path: ['outcome'],
      });
    }
  });

export const homePresentationRegionsSchema = z.object({
  tasks: homeRegionOutcomeSchema,
  care: homeRegionOutcomeSchema,
  plan: homeRegionOutcomeSchema,
});

export const homePresentationDataSchema = z.object({
  document: surfaceDocumentSchema,
  regions: homePresentationRegionsSchema,
});

export const homePresentationResponseSchema = apiEnvelope(homePresentationDataSchema);
export type HomeRegionOutcome = z.infer<typeof homeRegionOutcomeSchema>;
export type HomePresentationRegions = z.infer<typeof homePresentationRegionsSchema>;
export type HomePresentationData = z.infer<typeof homePresentationDataSchema>;
